import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getExhibitorExitPassDetailsUrl, submitExhibitorExitPassUrl, GET_ACCOUNT_Exit_PASS_DETAIL, getAccountExitPassDetailUrl, GET_EXHIBITOR_EXIT_PASS_DETAILS, SUBMIT_EXHIBITOR_EXIT_PASS, headers, GET_ACCOUNT_EXIT_PASS_DETAILS, deleteExitPassUrl, updateExhibitorExitPassUrl } from "../../../utils/constants";


export const getExhibitorExitPassDetails_action = (ContractorID, UUID, exhibitionID) => async (dispatch) => {
    try {
        // Use AccountID for vendor users (RoleId == 7), otherwise use the provided ContractorID
        const finalContractorID = sessionStorage.getItem("RoleIDSS") == 7 ?
            parseInt(sessionStorage.getItem("AccountIDSS")) : ContractorID;

        const finalExhRegistrationID = sessionStorage.getItem("RoleIDSS") == 7 ? null : sessionStorage.getItem("ExhRegistrationIDSS");
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: finalExhRegistrationID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID") == null ? exhibitionID : sessionStorage.getItem("sessionExhibitionID"),
            ContractorID: finalContractorID,
            UUID: UUID
        }

        const res = await axiosGet(getExhibitorExitPassDetailsUrl, params, headers)

        dispatch({
            type: GET_EXHIBITOR_EXIT_PASS_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const submitExhibitorExitPass_action = (ExitDate, CategoryType, VendorID, CompanyName, PersonName, MobileNo, EmailID, ExhExitPassList, IsFullOut, mailData, StatusID, isAgree, NoOfVehicle, vehicleList) => async (dispatch) => {
    try {
        console.log(ExitDate, CategoryType, VendorID, CompanyName, PersonName, MobileNo, EmailID, ExhExitPassList, IsFullOut, mailData, StatusID, isAgree, NoOfVehicle, vehicleList)
        const finalVendorID = sessionStorage.getItem("RoleIDSS") == 7 ?
            sessionStorage.getItem("AccountIDSS") :
            (VendorID == 0 ? VendorID : VendorID != '' ? VendorID : null);
        const finalExhRegistrationID = sessionStorage.getItem("RoleIDSS") == 7 ? null : sessionStorage.getItem("ExhRegistrationIDSS");
        var tempListofVehicles = [...vehicleList]
        tempListofVehicles.length > 0 && tempListofVehicles.map((item, i) => {
            item.Id = finalExhRegistrationID != '' && finalExhRegistrationID != null ? `Exh-${finalExhRegistrationID}` : `Vendor-${finalVendorID}`
            item.srNo = i
        })
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: finalExhRegistrationID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID") == null ? null : sessionStorage.getItem("sessionExhibitionID"),
            ExitDate: ExitDate != '' ? ExitDate : null,
            CategoryType: CategoryType != '' ? CategoryType : null,
            VendorID: finalVendorID,
            CompanyName: CompanyName != '' ? CompanyName : null,
            PersonName: PersonName != '' ? PersonName : null,
            MobileNo: MobileNo != '' ? MobileNo : null,
            EmailID: EmailID != '' ? EmailID : null,
            ExhExitPassList: ExhExitPassList,
            IsFullOut: IsFullOut,
            mailData: mailData,
            StatusID: StatusID,
            IsAgree: isAgree,
            NoOfVehicle: NoOfVehicle,
            vehicleList: tempListofVehicles
        }

        const res = await axiosPost(submitExhibitorExitPassUrl, params, headers)

        dispatch({
            type: SUBMIT_EXHIBITOR_EXIT_PASS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateExhibitorExitPass_action = (VendorID, ExitPassHdrID, ExitNo, ExhExitPassList, mailData, StatusID, NoOfVehicle, vehicleList) => async (dispatch) => {
    try {
        const finalVendorID = sessionStorage.getItem("RoleIDSS") == 7 ?
            sessionStorage.getItem("AccountIDSS") :
            (VendorID == 0 ? VendorID : VendorID != '' ? VendorID : null);

        const finalExhRegistrationID = sessionStorage.getItem("RoleIDSS") == 7 ? null : sessionStorage.getItem("ExhRegistrationIDSS");
        var tempListofVehicles = [...vehicleList]
        tempListofVehicles.length > 0 && tempListofVehicles.map((item, i) => {
            item.Id = finalExhRegistrationID != '' && finalExhRegistrationID != null ? `Exh-${finalExhRegistrationID}` : `Vendor-${finalVendorID}`
            item.srNo = i
        })
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: finalExhRegistrationID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID") == null ? null : sessionStorage.getItem("sessionExhibitionID"),
            ExitPassHdrID: ExitPassHdrID,
            VendorID: finalVendorID,
            ExhExitPassList: ExhExitPassList,
            // IsFullOut: IsFullOut,
            mailData: mailData,
            ExitNo: ExitNo,
            StatusID: StatusID,
            NoOfVehicle: NoOfVehicle,
            vehicleList: tempListofVehicles

        }

        const res = await axiosPost(updateExhibitorExitPassUrl, params, headers)

        dispatch({
            type: SUBMIT_EXHIBITOR_EXIT_PASS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getAccountExitPassDetail_action = (ExhExitPassHdrID, id) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhExitPassHdrID: ExhExitPassHdrID,
            ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getAccountExitPassDetailUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_EXIT_PASS_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteExitPass_action = (ExhExitPassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhExitPassHdrID: ExhExitPassHdrID,
            // ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(deleteExitPassUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_EXIT_PASS_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}